module.exports = __webpack_public_path__ + "img/CYM.c4f988dc.gif";